import Head from "next/head";

import TabsMenu from "components/global/TabsMenu/TabsMenu";
import ProfileSupport from "components/profileSupport/ProfileSupport/ProfileSupport";
import CONSTANTS from "config/constants";

const { TITLE } = CONSTANTS;

interface Props {}

const SupportPage = (props: Props) => {
  return (
    <>
      <Head>
        <title>Soporte | {TITLE}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <TabsMenu>
        <ProfileSupport />
      </TabsMenu>
    </>
  );
};

export default SupportPage;
